import { useDispatch, useSelector } from "react-redux";
import * as cardActions from "../../redux/card/card.actions";
import { markAllAsReadStart } from "./card.actions";
import { isMarkingAllAsReadSelector, markAllAsReadError, } from "./card.selectors";
export var useMarkAllAsRead = function () {
    var dispatch = useDispatch();
    var isMarkingAllAsRead = useSelector(function (state) {
        return isMarkingAllAsReadSelector(state);
    });
    var error = useSelector(function (state) {
        return markAllAsReadError(state);
    });
    var markAllAsRead = function (_a) {
        var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
        return dispatch(markAllAsReadStart.getAction({ onSuccess: onSuccess, onFailure: onFailure }));
    };
    var refetch = function () { return dispatch(cardActions.getCards.actions.start({})); };
    return {
        isMarkingAllAsRead: isMarkingAllAsRead,
        error: error,
        markAllAsRead: markAllAsRead,
        refetch: refetch,
    };
};
